import * as React from "react";
import * as JSON from "util/json";
import ClipboardIconButton from "components/common/ClipboardIconButton";
const JSONClipboardIconButton = ({ content, ...rest }) => /* @__PURE__ */ React.createElement(ClipboardIconButton, { text: JSON.stringify(content, null, 2), ...rest });
export default JSONClipboardIconButton;
